import useFetch from '../../../hooks/useFetch';
import useShortCode from '../../../hooks/useShortCode';
import useOrganisation from '../../../hooks/useOrganisation';
import DrmMetricsService from '../../../services/drm-metrics-service';
import { hasOrganisationSynced } from '../../../util/organisation';

const noop = async () => null;

export function useDrmMetric(metric, options = {}) {
  const shortCode = useShortCode();
  const organisation = useOrganisation(null, { suspense: false });
  const canFetch = Boolean(shortCode) && hasOrganisationSynced(organisation);

  const response = useFetch(
    canFetch ? DrmMetricsService.getMetric : noop,
    canFetch ? { shortCode, metric } : null,
    {
      suspense: false,
      throwOnError: false,
      cacheTime: 10 * 60,
      ...options,
    },
  );

  const apiData = response.data;
  const metricError = apiData && typeof apiData === 'object' && apiData.error === true;

  return {
    data: metricError ? null : apiData,
    loading: response.loading,
    error: metricError ? new Error(apiData.message || 'Metric computation failed') : response.error,
    refetch: response.refetch,
    shortCode,
  };
}

export default useDrmMetric;
